import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const CenteredContainer = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const BottomLabel = styled(Typography)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.5rem;
  color: #333;
`;

export const LadderActivityLoading = ({ label }: { label: string }) => {
  return (
    <CenteredContainer>
      <CircularProgress />
      <BottomLabel>{label}</BottomLabel>
    </CenteredContainer>
  );
};
